
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {Certificate, EndorsementLightViewModel} from "@/api-client";
    import {formatDate} from "@/formatting/dateFormatter";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import {BvTableFieldArray} from "bootstrap-vue";
    import CertificateStatusBadge from "@/features/shared/components/CertificateStatusBadge.vue";
import ClientsidePagingSelector from "@/components/ClientsidePagingSelector.vue";

    @Component({
        components: {
            CertificateStatusBadge,
            TableEmptySlot,
            ClientsidePagingSelector
        }
    })
    export default class CertificatesTable extends Vue {
        @Prop({ required: true})
        certificates!: Certificate[];
        @Prop({ default: false})
        withPagination!: boolean;

        paging = new ClientsidePaging();

        navigateToDetails(certificate: Certificate){
            this.$router.push({ name: "certificate-details", params:{id: certificate.id}});
        }

        fields: BvTableFieldArray = [
            { key: "documentNumber", label: this.$ls.Global_Label_DocumentNumber, sortable: true, thClass: 'w-15' },
            {
                key: "name",
                label: this.$ls.Global_Label_CertificateTypeName,
                sortable: true,
                thClass: "w-35",
                tdClass: "certificate-name",
            },
            {
                key: "documentType",
                label: this.$ls.Global_Label_DocumentType,
                sortable: true },
            {
                key: "issuedAt",
                label: this.$ls.Global_Label_IssueDateShort,
                sortable: true,
                formatter: (value: any, key: string, item: Certificate): string => formatDate(item.issuedAt),
            },
            {
                key: "validUntil",
                label: this.$ls.Global_Label_ValidUntil,
                sortable: true,
                formatter: (value: any, key: string, item: Certificate): string => formatDate(item.validUntil),
            },
            {
                key: "statusString",
                label: this.$ls.Global_Label_DocumentState,
                sortable: true,
                thClass: "w-10",
            },
            {
                key: "linkIcon",
                label: "",
                sortable: false,
                thClass: "w-5",
                tdClass: "table-actions",
            },
        ];
    }
